// if user pressed all selected button numOfTotalRecipents
// is used to calculate total number of recipients

import { TableResult } from "../interests-table/table-context";

// since the recipients variable only returns the current page's names
export const renderRecipients = (recipients: TableResult[], numOfTotalRecipents = 0, { from, to }: {from: null | number, to: null | number}): string => {
  if (from !== null && to !== null) {
    return `Selected Pages ${from + 1} - ${to + 1}; Total: ${numOfTotalRecipents} applications`;
  }
  if (!recipients || recipients.length < 1) {
    return "";
  }

  const { length } = recipients;
  switch (true) {
    case length === 2:
      return `${recipients[0].applicant_name}, and ${recipients[1].applicant_name}`;

    case length === 3:
      return (
        `${recipients[0].applicant_name
        }, ${
          recipients[1].applicant_name
        }, and ${
          recipients[2].applicant_name}`
      );

    case length > 3: {
      const firstThreerecipients = recipients.slice(0, 3)
        .map(recipient => recipient.applicant_name);
      const restrecipientsCount =
        numOfTotalRecipents > 0 ? numOfTotalRecipents - 3 : recipients.length - 3;
      return `${firstThreerecipients.join(", ")}, and + ${restrecipientsCount} more`;
    }

    default:
      return recipients[0].applicant_name;
  }
};
